module.exports = __webpack_public_path__ + "img/potential-gains-graphic.1ba83e1c.svg";